export default "__VITE_ASSET__CTxQHhmj__"